<template>
  <div class="tender-document">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item class="bigData-btn-contract" index="tenderContract">标书合同</el-menu-item>
      <el-menu-item class="bigData-btn-quotedTemp" index="quotedTemplate" :disabled="bidData.saveBtn?false:true">报价模板</el-menu-item>
      <el-menu-item v-if="bidData.isShowTab" index="gradeTemplate">综合评分模板</el-menu-item>
      <el-menu-item class="bigData-btn-organization" index="organizationGroup" :disabled="bidData.saveBtn?false:true">组织成员</el-menu-item>
      <el-menu-item class="bigData-btn-organization" index="BidReview" :disabled="bidData.saveBtn?false:true">标书审核</el-menu-item>
    </el-menu>
    <keep-alive :include="cachedViews">
        <component :is="defaultComponent" :TodoPath='TodoPath'></component>
    </keep-alive>
  </div>
</template>
<script>
import bigDataLog from '@/utils/bigDataLog';
import tenderContract from './components/tenderContract.vue';
import quotedTemplate from './components/quotedTemplate.vue';
import gradeTemplate from './components/gradeTemplate.vue';
import organizationGroup from './components/organizationGroup.vue';
import BidReview from './components/BidReview.vue';
export default {
    name: 'tenderdocument',
    components: {
        tenderContract,
        quotedTemplate,
        gradeTemplate,
        organizationGroup,
        BidReview
    },
    data() {
        return {
            bidData: {},
            activeIndex: 'tenderContract',
            defaultComponent: 'tenderContract',
            TodoPath: '',
            iflowId: this.$route.query.mbpmFlowId,
            cachedViews: ['organizationGroup']
        };
    },
    mounted() {
        this.bidData = this.loginState;
        if (this.$route.query.defaultComponent) {
            this.defaultComponent = this.$route.query.defaultComponent;
            this.activeIndex = this.$route.query.defaultComponent;
        }
        bigDataLog.sendDetailMessageByKey('bigData-btn-contract');
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.TodoPath = from.name;
        });
    },
    computed: {
        loginState() {
            return this.$store.state.bidData;
        }
    },
    methods: {
        handleSelect(key) {
            if (key === 'tenderContract') { this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId }); }
            this.defaultComponent = key;
        }
    },
    watch: {
        loginState(val) {
            this.bidData = val;
        }
    }

};
</script>
<style lang='less'>
.tender-document {
    .is-active{font-weight: 700}
    .el-menu-item{font-size: 14px;}
}
</style>